// extracted by mini-css-extract-plugin
export default {"host":"CrmCellTimeEditor_host__1Z8TW","footerSpan":"CrmCellTimeEditor_footerSpan__cOR5S"};